<template>
    <div>
        <form>
            <div class="profile-container">
                <div class="flex profile-container-title">
                    <img :src="profileIcon" alt="icon perfil">

                    <h4>Os meus dados</h4>
                </div>
                <p v-if="success" class="text-success error mb-3">
                    Informação atualizada
                </p>

                <div>
                    <div class="lg:flex">
                        <div class="w-full form-group input-container lg:pr-4">
                            <label class="font-body">Nome*</label>
                            <div class="input-box">
                                <input type="text" v-model="name"
                                       class="form-control" placeholder="O teu nome">
                            </div>
                            <span class="text-danger error"
                                  v-if="formError.name && formError.name.length > 0">{{ formError.name[0] }}</span>
                        </div>

                        <div class="w-full form-group input-container">
                            <label class="font-body">Email*</label>
                            <div class="input-box">
                                <input type="text" v-model="email" class="form-control" placeholder="O teu email">
                            </div>
                            <span class="text-danger error"
                                  v-if="formError.email && formError.email.length > 0">{{ formError.email[0] }}</span>
                        </div>


                    </div>
                    <div class="lg:flex">

                        <div class="w-full input-container phone-field lg:pr-4">
                            <label>número telefone*</label>
                            <phone-mask
                                :is-form="true"
                                @clearField="phoneNumber = null"
                                :default-country-code="countryCode"
                                :default-phone-number="phoneNumber"
                                v-model="phone"
                                class="phone-mask px-1"
                            >
                            </phone-mask>

                            <span class="text-danger error"
                                  v-if="formError.phone && formError.phone.length > 0">
                                  {{ formError.phone[0] }}
                            </span>
                        </div>

                        <div class="w-full lg:flex">
                            <div class="form-group input-container lg:pr-4">
                                <label class="font-body">Nome na fatura</label>
                                <div class="input-box">
                                    <input type="text" v-model="billingName" class="form-control"
                                           placeholder="O teu nome na fatura">
                                    <span class="text-danger error"
                                          v-if="formError.billing_name && formError.billing_name.length > 0">{{
                                            formError.billing_name[0]
                                        }}</span>
                                </div>
                            </div>


                            <div class="form-group input-container">
                                <label class="font-body">NIF</label>
                                <div class="input-box">
                                    <input type="text" v-model="nif" class="form-control" placeholder="O teu NIF">
                                </div>
                                <span class="text-danger error"
                                      v-if="formError.nif && formError.nif.length > 0">{{ formError.nif[0] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col-reverse justify-between mt-5 lg:flex-row">
                    <button class="btn-bg" :class="{'disabled': isLoading}" type="button" @click="updateProfile">
                        {{isLoading ? 'A guardar...' : 'Guardar'}}
                    </button>

                    <p class="text-center bottom-text lg:text-right">*campos obrigatórios</p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import profileIcon from '../../svg/ic_user_orange.svg'

export default {
    props: {
        customerData: {
            required: true
        },
    },
    data() {
        return {
            success: false,
            profileIcon: profileIcon,
            name: this.customerData.name,
            email: this.customerData.email,
            countryCode: this.customerData.country_code,
            phoneCode: this.customerData.phonecode,
            phoneNumber: this.customerData.phone,
            phone: '',
            nif: this.customerData.nif,
            billingName: this.customerData.billing_name,
            isLoading: false,
            formError: {
                'name': [],
                'email': [],
                'billing_name': [],
                'nif': [],
                'phonecode': [],
                'phone': [],
            },
        }
    },
    methods: {
        resetErrors() {
            this.formError = {
                'name': [],
                'email': [],
                'billing_name': [],
                'nif': [],
                'phonecode': [],
                'phone': [],
            }
        },
        fireSuccessMessage(){
            this.success = true
            setTimeout(() => { this.success = false }, 3000);
        },
        updateProfile() {
            // phone logic needs to be cleaned up
            let validatedPhone = (
                this.phone && this.phone.phoneNumber ?
                this.phone.phoneNumber :
                this.phoneNumber != null ?
                this.phoneNumber :
                typeof this.phone == 'string' ?
                this.phone : null
            )
            this.isLoading = true;
            this.$axios.post('/perfil', {
                'name': this.name,
                'email': this.email,
                'billing_name': this.billingName,
                'nif': this.nif,
                'phonecode': this.phone && this.phone.countryCallingCode || this.phoneCode,
                'phone': validatedPhone
            }).then((response) => {
                this.isLoading = false;
                this.fireSuccessMessage()
                this.resetErrors()
            })
                .catch((error) => {
                    switch (error.response.status) {
                        case 401:
                            this.$router.push('/logout');
                            break;
                        case 422:
                            this.formError = error.response.data;

                            this.isLoading = false;
                            break;
                        default:
                            //TODO
                            this.isLoading = false;
                            break;
                    }
                });
        }
    },
}
</script>

<style>

</style>
